import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { PageState } from '@/shared/ui/PageState';

function describeError(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unbekannter Fehler';
}

/**
 * Catches render and loader failures per route subtree, so a broken sub-page
 * never takes down the whole tournament portal.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  return (
    <PageState
      title="Da ist etwas schiefgelaufen"
      description={describeError(error)}
      action={
        <button
          type="button"
          onClick={() => {
            window.location.reload();
          }}
          className="bg-surface-raised hover:bg-surface-overlay border-line touch-target rounded-lg border px-5 py-3 font-medium transition-colors"
        >
          Neu laden
        </button>
      }
    />
  );
}
